/* eslint-disable @typescript-eslint/no-explicit-any */
import apiService from './api'
import { sanitizeQueryParams } from '../utility/helpers/apiHelper'
import { type SortOrderValue } from '@src/shared/constants/sort-order.constants'

interface GetProductsParams {
  page?: number
  pageSize?: number
  search?: string
  status?: string
  categoryId?: number | string
  subCategoryId?: number | string
  orderBy?: string
  orderDirection?: SortOrderValue
  [key: string]: any
}

export class ProductService {
  async getProducts(query: GetProductsParams) {
    return apiService.get('/products', { params: sanitizeQueryParams(query) })
  }

  async getProduct(id: string | number) {
    return apiService.get(`/products/${id}`)
  }

  async updateProductStatus(
    id: string | number,
    data: { status: string; rejectionReason?: string }
  ) {
    return apiService.patch(`/products/${id}/status`, data)
  }

  async updateProductFeatured(id: string | number, data: { isFeatured: boolean }) {
    return apiService.patch(`/products/${id}/featured`, data)
  }

  async updateProductTags(id: string | number, data: { tags: string[] }) {
    return apiService.patch(`/products/${id}/tags`, data)
  }

  async updateProductCategory(
    id: string | number,
    data: { categoryId: number | null }
  ) {
    return apiService.patch(`/products/${id}/category`, data)
  }

  async updateProductSubCategories(
    id: string | number,
    data: { subCategoryIds: number[] }
  ) {
    return apiService.patch(`/products/${id}/subcategories`, data)
  }
}

export const productService = new ProductService()
